import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

import { SaPaypalInvoiceService } from '../../services/SaPaypalInvoice.service';
declare var $:any;
@Component({
  selector: 'app-sa-paypal-invoice-details',
  templateUrl: './sa-paypal-invoice-details.component.html',
  styleUrls: ['./sa-paypal-invoice-details.component.css']
})
export class SaPaypalInvoiceDetailsComponent implements OnInit {
  invoiceID:string="";
  element:HTMLElement;
  newWin;
  sourceImage:string='/assets/Paypal/ips_icons/with paypal.svg';
  InvoiceDetails: any;
  showOverlayInvoice: boolean = false;
  DataDisplay: boolean = false;
  constructor(private _route: ActivatedRoute, private router: Router,private _service:SaPaypalInvoiceService) { }

  ngOnInit() {

    this.showOverlayInvoice = true;
    this._route.queryParams.subscribe(params => { this.invoiceID = params['Invoice_Id'] });
    this.getInvoiceDetails();
  }

  getInvoiceDetails() {
    if (this.invoiceID !== undefined) {
      this._service.getInvoiceInfo(this.invoiceID).subscribe(
      (data) => {
        this.InvoiceDetails = data;
        if (this.InvoiceDetails.id != null && this.InvoiceDetails.id !== undefined && this.InvoiceDetails.id != "") {
          this.DataDisplay = true;
        } else {
          this.DataDisplay = false;
        }
      }).add(() => this.showOverlayInvoice = false );
    }
    else {
      this.DataDisplay = false;
      this.showOverlayInvoice = false;
    }
  }

  onPrint(){
  let printContents, popupWin;
  printContents = document.getElementById('InvoicedetailsDiv').innerHTML;
  popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
  popupWin.document.open();
  popupWin.document.write(`
    <html>
      <head>

        <style>
        #circleoverlayinvoice {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%,-50%);
          width: 75px;
          height: 75px;
        }

        .loaderoverlayinvoice {
          width: calc(100% - 0px);
          height: calc(100% - 0px);
          border: 8px solid #162534;
          border-top: 8px solid #09f;
          border-radius: 50%;
          animation: rotate 5s linear infinite;
        }

        @keyframes rotate {
          100% {
            transform: rotate(360deg);
          }
        }
        .noResultImage {
          width: 35%;
          margin-left: 35%;
        }

        @media (max-width:556px) {
          .noResultImage {
            width: 50%;
          }
        }
          @media print{
            .nodisplayprint{
                display:none!important;
            }
          }
        .nodisplayprint:hover{
          cursor:pointer;
        }
        .bodybackground {
          background: #fafafa;
          margin: 1rem 0;
          height: 87vh;
          overflow-y: auto;
        }

        .bodybackgroundmain{
            background: #fafafa;
            margin:1rem 0;
            /* height:100vh; */
            overflow-y: hidden;
        }
        .invoice-outer{
            border:1px dotted #D9D9D9;
            background:#fff;
            width:60%;
            margin:0 auto;
            /* padding: 0 1rem; */
            font-size: 16px;
            color:#222;
        }

        h2{
            /* margin:0; */
        }

        .complete-button{


        }

        .dotted-border{
            border-bottom: 1px dotted #D9D9D9;
        }

        .dotted-border-top{
            border-top: 1px dotted #D9D9D9;
        }

        .first-grid{
            display: grid;
            grid-template-columns: 2fr 1fr;
            grid-column-gap: 1rem;
        }
        .left-border{
            border-left: 1.5px solid #d1d1d1;
        }
        .second-grid{
            display: grid;
            grid-template-columns: 1.5fr 1fr;
            grid-gap:1rem;
        }
        .third-grid{
            display: grid;
            grid-template-columns: 3fr 1fr 1fr 1fr;
            grid-gap:1rem;

        }
        .fourth-grid{
            display:grid;
            grid-template-columns: 1fr 2fr;
            grid-gap:1rem;
        }

        @media screen, print and (max-width:601px){
            .invoice-outer{
                width:90% !important;
            }

        }

        @media screen, print and (max-width:1500px){
            .invoice-outer{
                width:70% !important;
            }

        }


        @media screen, print and (max-width:901px){
            .invoice-outer{
                width:80% !important;
            }

            .stats{
                width:90% !important;
            }

        }

        @media screen, print and (max-width:601px){
            .stats{
                width:90% !important;
            }

        }
        .divGrid{
          display: grid;
          grid-template-columns: 1fr 1fr;
        }
        </style>
      </head>
  <body onload="window.print();window.close()">${printContents}</body>
    </html>`
  );


  popupWin.document.close();

}
GoBack(){
  this.router.navigate(['SA/Home/TransactionHistory']);
}
}
